// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"KpiArtifact-primaryButton-1S574o","cards":"KpiArtifact-cards-1j_Rkd","placeholder":"KpiArtifact-placeholder-LR0d3S"};